import { useEffect, useState } from 'react';
import { apiUrl } from '../../../api/apiUrl';
import http from '../../../api/axios';
import DataTable from '../../../components/table/DataTable';
import { PlusIcon } from '@heroicons/react/24/outline';
import { Link, useNavigate } from 'react-router-dom';
import Button from '../../../components/button/Button';
import { toast } from 'react-toastify';
import { useCurrentCompany } from '../../../hooks/useCompany';
import { CompanyBankAccount } from '../../../types/CompanyBankAccount';
import { paths } from '../../RouterContainer';
import { columns } from '../../../components/columns/Company/CompanyBankAccountColumns';
import { useTranslation } from '../../../context/translationContext';
interface Props {
  companyId: number;
}
/**
 * Page component represents bank accounts for current company
 */
export const CompanyBankAccountsPage = ({ companyId }: Props) => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [data, setData] = useState<CompanyBankAccount[] | null>(null);
  const { company } = useCurrentCompany();
  const isCurrent = window.location.pathname.includes(`current`);
  /**
   * Loads company bank accounts
   */
  const fetchData = async () => {
    if (!company) return;
    const response = await http.apiGet({
      url: `${apiUrl.COMPANY_BANK_ACCOUNT_LIST}?parentId=${company.id}`,
    });
    setData(response?.data);
  };

  useEffect(() => {
    fetchData();
  }, [company]);

  /**
   * Removes bank account item
   * @param id
   * @returns
   */
  const onRemoveItem = async (id: string | number) => {
    if (id === null) return;
    const response = await http.apiDelete({
      url: `${apiUrl.COMPANY_BANK_ACCOUNT_DELETE}?id=${id}`,
    });
    if (response?.status === 204) {
      toast.success('Success!');
      fetchData();
    }
  };

  /**
   * Redirects to company edit page
   * @param id of company
   */
  const onEditItem = (id: string | number) => {
    if (id === null) return;
    navigate(`/${paths.MY_COMPANIES}/${isCurrent ? `current` : companyId}/${paths.COMPANY_BANK_ACCOUNTS}/edit/${id}`);
  };

  return (
    <>
      <div className="flex justify-end">
        <Link to={`/${paths.MY_COMPANIES}/${isCurrent ? `current` : companyId}/${paths.COMPANY_BANK_ACCOUNTS}/create`}>
          <Button
            title={t('general.create-new')}
            color="green"
            icon={<PlusIcon className="w-4 h-4 mr-2" />}
          />
        </Link>
      </div>
      <DataTable
        data={data}
        columns={columns}
        handleRemove={onRemoveItem}
        handleEdit={onEditItem}
      />
    </>
  );
};
